import React from 'react';
import PropTypes from 'prop-types';

const HeaderClass = ({ discipline, schoolYear, dreAndMunicipio, periodoAno , schoolName}) => {

  return (
    <>
      <div
        className="container__background"
        style={{ gridTemplateColumns: "none", gridAutoFlow: "column" }}
      >
        {schoolName && (
          <div className="input__background">
            <span className="first__info">
             Escola: <span>{schoolName}</span>
            </span>
          </div>
        )}
        {schoolYear && (
          <div className="input__background">
            <span className="first__info">
              Série/Ano Escolar: <span>{schoolYear}</span>
            </span>
          </div>
        )}
        {dreAndMunicipio && (
          <div className="input__background">
            <span className="first__info">
              {'REDE'}: <span>{dreAndMunicipio}</span>
            </span>
          </div>
        )}
        {periodoAno && (
          <div className="input__background">
            <span className="first__info">
              Prova: <span>{periodoAno}</span>
            </span>
          </div>
        )}
      </div>
    </>
  );
};

HeaderClass.propTypes = {
  discipline: PropTypes.string,
  schoolYear: PropTypes.string,
  schoolName: PropTypes.string,
  dreAndMunicipio: PropTypes.string,
  periodoAno: PropTypes.string
};

export default HeaderClass;
